"use client";

import React, { Component, ErrorInfo, ReactNode } from "react";

// Installs the global JSON.stringify_safety net on every page load (this
// component is mounted in the root layout). See module for details.
import "@/lib/installSafeJson";

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = { hasError: false };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("Uncaught error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="p-4 text-destructive">Something went wrong.</div>
        )
      );
    }
    return this.props.children;
  }
}
